<template>
  <div class="flex items-center justify-center space-x-4 mt-4 bg-gray-100 p-4 rounded-b-lg">
    <p class="text-sm font-medium text-gray-700">¿Te sirvió la respuesta?</p>
    <button
      @click="sendFeedback(true)"
      class="px-4 py-2 text-sm font-semibold text-white bg-green-500 rounded-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 transition-colors"
    >
      Sí
    </button>
    <button
      @click="sendFeedback(false)"
      class="px-4 py-2 text-sm font-semibold text-white bg-red-500 rounded-lg hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 transition-colors"
    >
      No
    </button>
  </div>
</template>

<script setup>
import { useChatStore } from '../../stores/chatStore';

const chatStore = useChatStore();

const sendFeedback = (wasHelpful) => {
  const feedbackText = wasHelpful ? 'Sí, me sirvió.' : 'No, no me sirvió.';
  chatStore.sendMessageToElias(feedbackText);
};
</script>

